import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const styles = {
  message: css`
    color: ${props =>
      props.error ? COLORS.INPUT.ERROR.TEXT : COLORS.INPUT.TEXT};
    margin-top: 6px;
    padding-left: 0px !important;
  `,
  checkbox: css`
    ${props =>
      props.error
        ? css`
            border-color: #e0b4b4;
            color: #9f3a38;
            box-shadow: none;
            background-color: #fff6f6;
          `
        : ''}
  `
};

export default styles;
